module.exports = __webpack_public_path__ + "img/learner-quiz-Beaver.5a6e6bf4.png";